
<script setup>

  import { ref } from 'vue';

  import titles from '../images/activity-*-title.svg';

  import background from '../images/background.jpg';

  import backgrounds from '../images/activity-*-background.jpg';

  const activity = ref( null );

  const activities = [

    { alt: 'Hearing All the Stories' },

    { alt: 'Jim Crow Era Traveling' },

    { alt: 'The Essence of Life at Lewis' },

    { alt: 'Identifying Agents of Change' },

    { alt: 'Telling the Whole Story' }

  ]
  
  .map( ( props, index ) => ( { ...props, id: index + 1 } ) )

  .map( props => ( {
    
    ...props,

    title: titles[ props.id ],
    
    background: backgrounds[ props.id ]
  
  } ) );

</script>

<template>

  <section>

    <div class="grid min-h-view">

      <template v-for="{ id, background } in activities">

        <div
      
          :class="[ 'row-start-1 col-start-1 bg-fixed bg-cover bg-center transition-opacity duration-200 opacity-0', { 'opacity-100': activity && activity === id } ]"
        
          :style="{ 'background-image': `radial-gradient( rgba( 24, 22, 21, 0.6 ) 40%, rgba( 24, 22, 21, 1 ) ), url( ${ background } )` }" />

      </template>

      <div
    
        :class="[ 'row-start-1 col-start-1 bg-fixed bg-cover bg-center transition-opacity duration-200 opacity-0', { 'opacity-100': ! activity } ]"
      
        :style="{ 'background-image': `radial-gradient( rgba( 24, 22, 21, 0.6 ) 40%, rgba( 24, 22, 21, 1 ) ), url( ${ background } )` }" />

      <div class="row-start-1 col-start-1 xl:grid xl:grid-cols-5 p-6">

        <RouterLink v-for="( { id, title, alt }, index ) in activities" :to="`/activity/${ id }`"
        
          class="relative group flex items-center justify-center w-full min-h-[320px] h-[35vh] xl:h-full"
          
          @focus="activity = id" @pointerover="activity = id" @pointerout="activity = null">

          <div :class="[ 'absolute xl:hidden inset-x-0 top-0 h-px', { 'hidden': index < 1 } ]"
          
            style="background-image: linear-gradient( to right, transparent 10%, rgba( 255, 255, 255, 0.6 ) 50%, transparent 90% )" />

          <div :class="[ 'absolute hidden inset-y-0 left-0 w-px', { 'xl:block': index > 0 } ]"
          
            style="background-image: linear-gradient( to bottom, transparent 10%, rgba( 255, 255, 255, 0.6 ) 50%, transparent 90% )" />

          <div class="scale-90 group-hover:scale-100 transition-transform duration-200 drop-shadow-[0_0_15px_rgba(0,0,0,1)]">

            <img :class="[ 'w-full max-w-[320px] pointer-events-none px-5 transition-opacity duration-200', { 'opacity-40': activity && activity !== id } ]"
            
              draggable="false" :src="title" :alt="alt" />

          </div>

        </RouterLink>

      </div>

    </div>

  </section>

</template>
